import ContactForm from './ContactForm'; // Import the existing contact form
import Image from 'next/image';
import { MapPin, PhoneCall, Check, Mail, Star } from 'lucide-react'; // Import Lucide icons

const ContactUs = () => {
  return (

    <section id="quote-form" className="relative bg-background overflow-hidden pt-16">
      {/* ✅ Lazy background image via next/image */}
      <div className="absolute inset-0 z-0">
        <Image
          src="/hero/best-home-remodling-contractor-in-los-angeles.webp"
          alt="Contact background"
          fill
          className="object-cover object-left lg:object-center"
          sizes="100vw"
          priority={false} // lazy-loads automatically
        />
        <div className="absolute inset-0 bg-black opacity-20" />
      </div>

      {/* Main Content */}
      <div className="relative max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 px-4">
        {/* Left Side - Contact Info and More Content */}
        <div className="flex flex-col justify-between mt-[30px] lg:mt-[100px]">
          <div>
            {/* 5 Stars */}
            <span className="stars flex mb-5">
              {[...Array(5)].map((_, idx) => (
                <Star key={idx} className="w-6 h-6 mr-2 fill-primary text-transparent" />
              ))}
            </span>

            <p className="text-2xl text-white mb-8 font-light font-gilda">
              We’re here to help with all your home remodeling needs. Reach out for a free consultation or any inquiries you have about our services.
            </p>

            {/* Phone Contact */}
            <div className="flex items-center space-x-3 mb-6">
              <PhoneCall className="text-white text-light w-[45px] h-[45px]" />
              <div>
                <p className="text-white capitalize font-light text-lg">Free Consultation</p>
                <a href="tel:+13233004130" className="text-white text-2xl tracking-[1px] hover:text-primary transition duration-300">(323) 300-4130</a>
              </div>
            </div>

            <div className="flex items-center space-x-1 mb-6">
              <Check className="text-white text-light w-[10px] h-[10px]" />
              <p className="text-white font-light">Call us, it's free.</p>
            </div>

            {/* Additional Information */}
            <div className="text-lg text-white">
              <p className="mb-4">
                Our expert team has been serving Los Angeles and surrounding areas for over a decade. Whether you are looking to remodel your kitchen, bathroom, or entire home, we provide top-notch services to make your vision a reality.
              </p>
              <p className="mb-4">
                Let’s start transforming your space into something amazing. Get in touch today to explore how we can bring your project to life.
              </p>
            </div>
          </div>
        </div>

        {/* Right Side - Contact Form */}
        <div className="relative z-10">
          <ContactForm />
        </div>
      </div>

      {/* Award Logos */}
      <div className="relative bg-white w-screen left-0 right-0 py-6 mt-20 lg:mt-[-4.5rem] flex justify-center space-x-2 lg:space-x-[25px] lg:justify-start lg:pl-[100px] items-center">
        {/* <Image src="/BBB-Accredited-Business.webp" alt="BBB Accredited Business Remodeling Contractor" title="BBB Accredited Business Remodeling Contractor" width={50} height={50} className="w-[50px] h-[50px] lg:w-[100px] lg:h-[100px]" /> */}
        <a target="_blank" rel="noopener noreferrer" href='https://voyagela.com/interview/inspiring-conversations-with-matan-bodek-of-modern-build-home-remodeling'><Image src="/voyagela-logo.webp" alt="Modern Build Home Remodeling best constrution company in los angeles" title="Inspiring Conversations with Matan Bodek Owner of Modern Build Home Remodeling best constrution company in los angeles"  width={70} height={15} className="w-[70px] h-[15px] lg:w-[117px] lg:h-[25px]" />
          <span className="sr-only">Inspiring Conversations with Matan Bodek Owner of Modern Build Home Remodeling best constrution company in los angeles</span>
        </a>
        <Image src="/Home-Advisor-Screened.webp" alt="Home Advisor Screened Remodeling Contractor" title="Home Advisor Screened Remodeling Contractor" width={50} height={50} className="w-[50px] h-[50px] lg:w-[70px] lg:h-[70px]"/>
        <Image src="/Home-Advisor-Elite.webp" alt="Home Advisor Elite Remodeling Contractor" title="Home Advisor Elite Remodeling Contractor" width={50} height={50} className="w-[50px] h-[50px] lg:w-[70px] lg:h-[70px]" />
        <Image src="/Home-Advisor-Top-Rated.webp" alt="Home Advisor Top Rated Remodeling Contractor" title="Home Advisor Top Rated Remodeling Contractor" width={50} height={50} className="w-[50px] h-[50px] lg:w-[70px] lg:h-[70px]" />
        <a target="_blank" rel="noopener noreferrer" href='https://nextdoor.com/pages/modern-build-home-remodeling-studio-city-ca/'><Image src="/nextdoor.webp" alt="Best 2025 Remodeling and Repairing general Contractors in Studio City" title="Best 2025 nextdoor Remodeling and Repairing general Contractors in Studio City"  width={54} height={48} className="w-[54px] h-[48px] lg:w-[80px] lg:h-[71px]" />
          <span className="sr-only">Best 2025 nextdoor Remodeling and Repairing general Contractors in Studio City</span>
        </a>
        <a target="_blank" rel="noopener noreferrer" href='https://www.yelp.com/biz/modern-build-home-remodeling-los-angeles'><Image src="/yelpAdvertisingPartner.webp" alt="Yelp Top Rated Remodeling Contractor in Los Angeles" title="Best Yelp Top Rated Remodeling Contractor in Los Angeles" width={50} height={50} className="w-[40px] h-[40px] lg:w-[60px] lg:h-[60px]" />
          <span className="sr-only">Best Yelp Top Rated Remodeling Contractor in Los Angeles</span>
        </a>
      </div>
    </section>
  );
};

export default ContactUs;
